import { ReactElement } from 'react'
import { HorizontalRuleProps } from './typing'
import { HR } from './subcomponents'

const HorizontalRule = (props: HorizontalRuleProps): ReactElement => {
  return <HR aria-hidden="true" {...props} />
}

export default HorizontalRule
